module.exports = __webpack_public_path__ + "static/media/how_disputes_work1.54e213a3.png";